// @flow

export default async (url: String, prefix: String = "", options: Object) => {
    console.log(url, options);
    const response = await fetch(url, { credentials: "include", ...options });

    if (!response.ok) {
        const msg = `${prefix} fetch error, status = ${response.status}`;
        const err = new Error(msg);
        err.status = response.status;

        throw err;
    }

    return response.json().catch(err => {
        const jsonParseError = err;
        jsonParseError.message = `${prefix}JSON parse error!`;
        throw jsonParseError;
    });
};



// WEBPACK FOOTER //
// ./src/rest/utils/fetchIncludeCredentials.js